/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
	type BaseResponse,
	BaseResponseFromJSON,
	BaseResponseToJSON,
} from '../models/BaseResponse';
import {
	type CaseGetControlCommandResult,
	CaseGetControlCommandResultFromJSON,
	CaseGetControlCommandResultToJSON,
} from '../models/CaseGetControlCommandResult';
import {
	type CaseUpdateControlCommandParams,
	CaseUpdateControlCommandParamsFromJSON,
	CaseUpdateControlCommandParamsToJSON,
} from '../models/CaseUpdateControlCommandParams';
import {
	type CaseUpdateControlCommandResult,
	CaseUpdateControlCommandResultFromJSON,
	CaseUpdateControlCommandResultToJSON,
} from '../models/CaseUpdateControlCommandResult';
import {
	type CaseV2CancelCommandResponse,
	CaseV2CancelCommandResponseFromJSON,
	CaseV2CancelCommandResponseToJSON,
} from '../models/CaseV2CancelCommandResponse';
import {
	type CustomerJourneyQuestionsAnswersRequest,
	CustomerJourneyQuestionsAnswersRequestFromJSON,
	CustomerJourneyQuestionsAnswersRequestToJSON,
} from '../models/CustomerJourneyQuestionsAnswersRequest';
import {
	type EasyClaimAppState,
	EasyClaimAppStateFromJSON,
	EasyClaimAppStateToJSON,
} from '../models/EasyClaimAppState';
import {
	type FeedbackType,
	FeedbackTypeFromJSON,
	FeedbackTypeToJSON,
} from '../models/FeedbackType';
import { type Language, LanguageFromJSON, LanguageToJSON } from '../models/Language';
import {
	type SaveCaseEventRequest,
	SaveCaseEventRequestFromJSON,
	SaveCaseEventRequestToJSON,
} from '../models/SaveCaseEventRequest';
import {
	type TryFinishDocumentUploadRequest,
	TryFinishDocumentUploadRequestFromJSON,
	TryFinishDocumentUploadRequestToJSON,
} from '../models/TryFinishDocumentUploadRequest';

export interface ApiV1CaseAddFeedbackPostRequest {
	caseId: string;
	feedbackComment?: string;
	feedbackRating?: number;
	feedbackType?: FeedbackType;
}

export interface ApiV1CaseCustomerJourneyQuestionsAnswersPutRequest {
	customerJourneyQuestionsAnswersRequest: CustomerJourneyQuestionsAnswersRequest;
}

export interface ApiV1CaseDocumentsFinishUploadPostRequest {
	tryFinishDocumentUploadRequest: TryFinishDocumentUploadRequest;
}

export interface ApiV2CaseCaseIdCancelPostRequest {
	caseId: string;
}

export interface ApiV2CaseCaseIdDamagePatchRequest {
	caseId: string;
	body?: string;
}

export interface ApiV2CaseCaseIdEventsPostRequest {
	caseId: string;
	saveCaseEventRequest: SaveCaseEventRequest;
}

export interface ApiV2CaseCaseIdScreensScreenIdControlsControlIdGetRequest {
	caseId: string;
	screenId: EasyClaimAppState;
	controlId: string;
	language?: Language;
}

export interface ApiV2CaseCaseIdScreensScreenIdControlsControlIdPostRequest {
	caseId: string;
	screenId: EasyClaimAppState;
	controlId: string;
	caseUpdateControlCommandParams: CaseUpdateControlCommandParams;
	language?: Language;
}

/**
 *
 */
export class CaseApi extends runtime.BaseAPI {
	/**
	 * Creates request options for apiV1CaseAddFeedbackPost without sending the request
	 */
	async apiV1CaseAddFeedbackPostRequestOpts(
		requestParameters: ApiV1CaseAddFeedbackPostRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV1CaseAddFeedbackPost().'
			);
		}

		const queryParameters: any = {};

		if (requestParameters['caseId'] != null) {
			queryParameters['caseId'] = requestParameters['caseId'];
		}

		if (requestParameters['feedbackComment'] != null) {
			queryParameters['feedbackComment'] = requestParameters['feedbackComment'];
		}

		if (requestParameters['feedbackRating'] != null) {
			queryParameters['feedbackRating'] = requestParameters['feedbackRating'];
		}

		if (requestParameters['feedbackType'] != null) {
			queryParameters['feedbackType'] = requestParameters['feedbackType'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/case/add-feedback`;

		return {
			path: urlPath,
			method: 'POST',
			headers: headerParameters,
			query: queryParameters,
		};
	}

	/**
	 */
	async apiV1CaseAddFeedbackPostRaw(
		requestParameters: ApiV1CaseAddFeedbackPostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<BaseResponse>> {
		const requestOptions = await this.apiV1CaseAddFeedbackPostRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) => BaseResponseFromJSON(jsonValue));
	}

	/**
	 */
	async apiV1CaseAddFeedbackPost(
		requestParameters: ApiV1CaseAddFeedbackPostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<BaseResponse> {
		const response = await this.apiV1CaseAddFeedbackPostRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Creates request options for apiV1CaseCustomerJourneyQuestionsAnswersPut without sending the request
	 */
	async apiV1CaseCustomerJourneyQuestionsAnswersPutRequestOpts(
		requestParameters: ApiV1CaseCustomerJourneyQuestionsAnswersPutRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['customerJourneyQuestionsAnswersRequest'] == null) {
			throw new runtime.RequiredError(
				'customerJourneyQuestionsAnswersRequest',
				'Required parameter "customerJourneyQuestionsAnswersRequest" was null or undefined when calling apiV1CaseCustomerJourneyQuestionsAnswersPut().'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/case/customer-journey-questions-answers`;

		return {
			path: urlPath,
			method: 'PUT',
			headers: headerParameters,
			query: queryParameters,
			body: CustomerJourneyQuestionsAnswersRequestToJSON(
				requestParameters['customerJourneyQuestionsAnswersRequest']
			),
		};
	}

	/**
	 */
	async apiV1CaseCustomerJourneyQuestionsAnswersPutRaw(
		requestParameters: ApiV1CaseCustomerJourneyQuestionsAnswersPutRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<BaseResponse>> {
		const requestOptions =
			await this.apiV1CaseCustomerJourneyQuestionsAnswersPutRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) => BaseResponseFromJSON(jsonValue));
	}

	/**
	 */
	async apiV1CaseCustomerJourneyQuestionsAnswersPut(
		requestParameters: ApiV1CaseCustomerJourneyQuestionsAnswersPutRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<BaseResponse> {
		const response = await this.apiV1CaseCustomerJourneyQuestionsAnswersPutRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 * Creates request options for apiV1CaseDocumentsFinishUploadPost without sending the request
	 */
	async apiV1CaseDocumentsFinishUploadPostRequestOpts(
		requestParameters: ApiV1CaseDocumentsFinishUploadPostRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['tryFinishDocumentUploadRequest'] == null) {
			throw new runtime.RequiredError(
				'tryFinishDocumentUploadRequest',
				'Required parameter "tryFinishDocumentUploadRequest" was null or undefined when calling apiV1CaseDocumentsFinishUploadPost().'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/case/documents/finish-upload`;

		return {
			path: urlPath,
			method: 'POST',
			headers: headerParameters,
			query: queryParameters,
			body: TryFinishDocumentUploadRequestToJSON(
				requestParameters['tryFinishDocumentUploadRequest']
			),
		};
	}

	/**
	 */
	async apiV1CaseDocumentsFinishUploadPostRaw(
		requestParameters: ApiV1CaseDocumentsFinishUploadPostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<BaseResponse>> {
		const requestOptions =
			await this.apiV1CaseDocumentsFinishUploadPostRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) => BaseResponseFromJSON(jsonValue));
	}

	/**
	 */
	async apiV1CaseDocumentsFinishUploadPost(
		requestParameters: ApiV1CaseDocumentsFinishUploadPostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<BaseResponse> {
		const response = await this.apiV1CaseDocumentsFinishUploadPostRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 * Creates request options for apiV2CaseCaseIdCancelPost without sending the request
	 */
	async apiV2CaseCaseIdCancelPostRequestOpts(
		requestParameters: ApiV2CaseCaseIdCancelPostRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV2CaseCaseIdCancelPost().'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v2/case/{caseId}/cancel`;
		urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

		return {
			path: urlPath,
			method: 'POST',
			headers: headerParameters,
			query: queryParameters,
		};
	}

	/**
	 */
	async apiV2CaseCaseIdCancelPostRaw(
		requestParameters: ApiV2CaseCaseIdCancelPostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<CaseV2CancelCommandResponse>> {
		const requestOptions = await this.apiV2CaseCaseIdCancelPostRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			CaseV2CancelCommandResponseFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiV2CaseCaseIdCancelPost(
		requestParameters: ApiV2CaseCaseIdCancelPostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<CaseV2CancelCommandResponse> {
		const response = await this.apiV2CaseCaseIdCancelPostRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Creates request options for apiV2CaseCaseIdDamagePatch without sending the request
	 */
	async apiV2CaseCaseIdDamagePatchRequestOpts(
		requestParameters: ApiV2CaseCaseIdDamagePatchRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV2CaseCaseIdDamagePatch().'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v2/case/{caseId}/damage`;
		urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

		return {
			path: urlPath,
			method: 'PATCH',
			headers: headerParameters,
			query: queryParameters,
			body: requestParameters['body'] as any,
		};
	}

	/**
	 */
	async apiV2CaseCaseIdDamagePatchRaw(
		requestParameters: ApiV2CaseCaseIdDamagePatchRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<BaseResponse>> {
		const requestOptions = await this.apiV2CaseCaseIdDamagePatchRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) => BaseResponseFromJSON(jsonValue));
	}

	/**
	 */
	async apiV2CaseCaseIdDamagePatch(
		requestParameters: ApiV2CaseCaseIdDamagePatchRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<BaseResponse> {
		const response = await this.apiV2CaseCaseIdDamagePatchRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Creates request options for apiV2CaseCaseIdEventsPost without sending the request
	 */
	async apiV2CaseCaseIdEventsPostRequestOpts(
		requestParameters: ApiV2CaseCaseIdEventsPostRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV2CaseCaseIdEventsPost().'
			);
		}

		if (requestParameters['saveCaseEventRequest'] == null) {
			throw new runtime.RequiredError(
				'saveCaseEventRequest',
				'Required parameter "saveCaseEventRequest" was null or undefined when calling apiV2CaseCaseIdEventsPost().'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v2/case/{caseId}/events`;
		urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));

		return {
			path: urlPath,
			method: 'POST',
			headers: headerParameters,
			query: queryParameters,
			body: SaveCaseEventRequestToJSON(requestParameters['saveCaseEventRequest']),
		};
	}

	/**
	 */
	async apiV2CaseCaseIdEventsPostRaw(
		requestParameters: ApiV2CaseCaseIdEventsPostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<BaseResponse>> {
		const requestOptions = await this.apiV2CaseCaseIdEventsPostRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) => BaseResponseFromJSON(jsonValue));
	}

	/**
	 */
	async apiV2CaseCaseIdEventsPost(
		requestParameters: ApiV2CaseCaseIdEventsPostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<BaseResponse> {
		const response = await this.apiV2CaseCaseIdEventsPostRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Creates request options for apiV2CaseCaseIdScreensScreenIdControlsControlIdGet without sending the request
	 */
	async apiV2CaseCaseIdScreensScreenIdControlsControlIdGetRequestOpts(
		requestParameters: ApiV2CaseCaseIdScreensScreenIdControlsControlIdGetRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV2CaseCaseIdScreensScreenIdControlsControlIdGet().'
			);
		}

		if (requestParameters['screenId'] == null) {
			throw new runtime.RequiredError(
				'screenId',
				'Required parameter "screenId" was null or undefined when calling apiV2CaseCaseIdScreensScreenIdControlsControlIdGet().'
			);
		}

		if (requestParameters['controlId'] == null) {
			throw new runtime.RequiredError(
				'controlId',
				'Required parameter "controlId" was null or undefined when calling apiV2CaseCaseIdScreensScreenIdControlsControlIdGet().'
			);
		}

		const queryParameters: any = {};

		if (requestParameters['language'] != null) {
			queryParameters['language'] = requestParameters['language'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v2/case/{caseId}/screens/{screenId}/controls/{controlId}`;
		urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
		urlPath = urlPath.replace(
			'{screenId}',
			encodeURIComponent(String(requestParameters['screenId']))
		);
		urlPath = urlPath.replace(
			'{controlId}',
			encodeURIComponent(String(requestParameters['controlId']))
		);

		return {
			path: urlPath,
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		};
	}

	/**
	 */
	async apiV2CaseCaseIdScreensScreenIdControlsControlIdGetRaw(
		requestParameters: ApiV2CaseCaseIdScreensScreenIdControlsControlIdGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<CaseGetControlCommandResult>> {
		const requestOptions =
			await this.apiV2CaseCaseIdScreensScreenIdControlsControlIdGetRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			CaseGetControlCommandResultFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiV2CaseCaseIdScreensScreenIdControlsControlIdGet(
		requestParameters: ApiV2CaseCaseIdScreensScreenIdControlsControlIdGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<CaseGetControlCommandResult> {
		const response = await this.apiV2CaseCaseIdScreensScreenIdControlsControlIdGetRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 * Creates request options for apiV2CaseCaseIdScreensScreenIdControlsControlIdPost without sending the request
	 */
	async apiV2CaseCaseIdScreensScreenIdControlsControlIdPostRequestOpts(
		requestParameters: ApiV2CaseCaseIdScreensScreenIdControlsControlIdPostRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV2CaseCaseIdScreensScreenIdControlsControlIdPost().'
			);
		}

		if (requestParameters['screenId'] == null) {
			throw new runtime.RequiredError(
				'screenId',
				'Required parameter "screenId" was null or undefined when calling apiV2CaseCaseIdScreensScreenIdControlsControlIdPost().'
			);
		}

		if (requestParameters['controlId'] == null) {
			throw new runtime.RequiredError(
				'controlId',
				'Required parameter "controlId" was null or undefined when calling apiV2CaseCaseIdScreensScreenIdControlsControlIdPost().'
			);
		}

		if (requestParameters['caseUpdateControlCommandParams'] == null) {
			throw new runtime.RequiredError(
				'caseUpdateControlCommandParams',
				'Required parameter "caseUpdateControlCommandParams" was null or undefined when calling apiV2CaseCaseIdScreensScreenIdControlsControlIdPost().'
			);
		}

		const queryParameters: any = {};

		if (requestParameters['language'] != null) {
			queryParameters['language'] = requestParameters['language'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v2/case/{caseId}/screens/{screenId}/controls/{controlId}`;
		urlPath = urlPath.replace('{caseId}', encodeURIComponent(String(requestParameters['caseId'])));
		urlPath = urlPath.replace(
			'{screenId}',
			encodeURIComponent(String(requestParameters['screenId']))
		);
		urlPath = urlPath.replace(
			'{controlId}',
			encodeURIComponent(String(requestParameters['controlId']))
		);

		return {
			path: urlPath,
			method: 'POST',
			headers: headerParameters,
			query: queryParameters,
			body: CaseUpdateControlCommandParamsToJSON(
				requestParameters['caseUpdateControlCommandParams']
			),
		};
	}

	/**
	 */
	async apiV2CaseCaseIdScreensScreenIdControlsControlIdPostRaw(
		requestParameters: ApiV2CaseCaseIdScreensScreenIdControlsControlIdPostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<CaseUpdateControlCommandResult>> {
		const requestOptions =
			await this.apiV2CaseCaseIdScreensScreenIdControlsControlIdPostRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			CaseUpdateControlCommandResultFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiV2CaseCaseIdScreensScreenIdControlsControlIdPost(
		requestParameters: ApiV2CaseCaseIdScreensScreenIdControlsControlIdPostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<CaseUpdateControlCommandResult> {
		const response = await this.apiV2CaseCaseIdScreensScreenIdControlsControlIdPostRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}
}
